<!-- main-layout.component.html -->
<div class="flex h-screen w-screen overflow-hidden">
  <div class="h-full flex-shrink-0 surface-50 border-right-1 surface-border" style="width: 250px;">
    <div class="p-4 flex align-items-center">
    </div>

    <div class="p-3">
      <app-nav-menu></app-nav-menu>
    </div>
  </div>

  <div class="flex-grow-1 flex flex-column h-full">
    <!-- top -->
    <div
      class="surface-0 border-bottom-1 surface-border p-3 flex align-items-center justify-content-between flex-shrink-0">
      <!-- Left -->
      <div>
        <!--        <p-breadcrumb [model]="breadcrumbItems"></p-breadcrumb>-->
      </div>

      <!-- Center -->
      <div class="flex-none" style="min-width: 800px;">
        <app-search-bar></app-search-bar>
      </div>

      <!-- Right -->
      <div class="flex align-items-center gap-2">
        <app-lang-select></app-lang-select>
        <app-user-avatar></app-user-avatar>
        <!--        <p-button icon="pi pi-cog" styleClass="p-button-text"></p-button>-->
        <!--        <p-button icon="pi pi-sign-out" styleClass="p-button-text ml-2"></p-button>-->
      </div>
    </div>

    <div class="flex-grow-1 overflow-auto p-4">
      <div class="h-full">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Footer -->
    <!--    <div class="surface-50 border-top-1 surface-border p-3 text-center flex-shrink-0">-->
    <!--      <p class="text-sm text-color-secondary m-0">© 2025 pixie</p>-->
    <!--    </div>-->
  </div>
</div>
